export const settings = {
  main: "Settings",
};
